/**
 * @license
 * Copyright DagonMetric. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found under the LICENSE file in the root directory of this source tree.
 */

/**
 * Entry point for all public APIs of the ng-config-firebase-remote-config package.
 */

export * from './firebase-remote-config-provider';
export * from './firebase-remote-config-provider-options';
export * from './firebase-remote-config-provider.module';
